<div *ngIf="isAvailableStatistics && (me$ | async).id !== user_id"
     class="subscribe"
     [class.mobile]="deviceService.isMobile()"
     [class.separate]="separate"
     (click)="onToggleSubscribe()">
  <p class="subscribe-text">
    {{ (isSubscribed ? 'user-profile.subscribed' : 'content.subscribe') | translate }}
  </p>
</div>

